/**
 * en-GB messages added by Phase 1 task S3 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s3EnGB = {
    'fieldType.text': 'Short text',
    'fieldType.text.desc': 'A single line, such as a company name or car registration',
    'fieldType.long_text': 'Long text',
    'fieldType.long_text.desc': 'Several lines, such as a reason for the visit',
    'fieldType.number': 'Number',
    'fieldType.number.desc': 'A number, optionally with limits and a unit',
    'fieldType.email': 'Email address',
    'fieldType.email.desc': 'An email address, checked for a valid shape',
    'fieldType.phone': 'Phone number',
    'fieldType.phone.desc': 'A telephone number',
    'fieldType.date': 'Date',
    'fieldType.date.desc': 'A calendar date',
    'fieldType.select': 'Drop-down list',
    'fieldType.select.desc': 'Pick one answer from a list you set up',
    'fieldType.multi_select': 'Multiple choice',
    'fieldType.multi_select.desc': 'Pick any number of answers from a list',
    'fieldType.yes_no': 'Yes or no',
    'fieldType.yes_no.desc': 'A yes or no question, optionally with one answer required',
    'fieldType.signature': 'Signature',
    'fieldType.signature.desc': 'The person signs on the screen',
    'fieldType.acknowledge': 'Read and acknowledge',
    'fieldType.acknowledge.desc': 'A message the person must tick to say they have read',
    'fieldType.host': 'Person visiting',
    'fieldType.host.desc': 'Choose the member being visited',
    'error.field_required': 'Please answer this question.',
    'error.field_must_acknowledge': 'Please tick the box to confirm.',
    'error.field_invalid': 'That answer is not valid.',
    'error.field_too_long': 'That answer is too long.',
    'error.field_number': 'Please enter a number.',
    'error.field_whole_number': 'Please enter a whole number.',
    'error.field_range': 'That number is outside the allowed range.',
    'error.field_email': 'Please enter a valid email address.',
    'error.field_phone': 'Please enter a valid phone number.',
    'error.field_date': 'Please enter a valid date.',
    'error.field_option': 'Please choose one of the listed answers.',
    'error.field_answer_not_allowed': 'That answer is not allowed.',
    'error.field_config_invalid': 'The settings for this question are not valid.',
    'error.field_options_required': 'Add at least one answer to the list.',
    'error.field_options_invalid': 'The list of answers is not valid. Each answer needs its own name.',
    'error.field_type_unknown': 'That question type does not exist.',
    'error.field_scope_not_allowed': 'That question type cannot be used here.',
    'error.field_group_not_visible': 'One of the chosen groups is not shown at this site.',
    'error.field_group_not_repeat': 'Personal fields belong to repeat groups only.',
    'error.field_sensitive_not_starrable': 'A private question cannot be shown on member cards or the today board.',
    'error.field_has_values': 'This question already has answers, so it cannot be deleted. Archive it instead.',
    'error.too_many_fields': 'A group can have at most 15 personal fields, including full name, email, phone and role.',
    'error.too_many_starred': 'You can star at most 4 questions in one list.',
};
//# sourceMappingURL=s3.js.map